import { IDatasource, Schema } from "@cak-legacy/generation-core";
import { Form, FormButtonContext, FormButtons, FormSubmitContext, SelectLibrary } from "@cak-legacy/generation-form";
import * as React from "react";
import { translate } from "../Locales/translator";

export interface IEditFormProps {
  getSchema: () => Schema;
  isLoading?: boolean;
  handleSubmit: (values: any, event: any) => void;
  defaultValues: any;
  datasources?: IDatasource[];
  handlePrevious?: (values: any, event: any) => void;
  introText?: string | React.ReactNode;
  outroText?: string | React.ReactNode;
  onShowButtons?: (values: any) => boolean;
  customClass?: string;
}

export const EditForm = (props: IEditFormProps) => {
  const buttonList: FormButtons[] = [
    {
      type: "submit",
      handle: (values: any, event: React.FormEvent, _: FormSubmitContext) =>
        props.handleSubmit(values, event),
      id: "volgendeButton",
      label: translate("Volgende"),
      layout: "primary",
      isLoading: props.isLoading
    }
  ];

  const handlePrevious = props.handlePrevious;
  if (handlePrevious !== undefined) {
    buttonList.unshift({
      type: "button",
      handle: (formButtonContext: FormButtonContext) => {
        formButtonContext.handleSubmit(
          (data: any, event: React.FormEvent) => {
            handlePrevious(data, event);
          },
          (_, event: React.FormEvent) => {
            handlePrevious?.({}, event);
          }
        );
      },
      id: "vorigeButton",
      label: translate("Vorige"),
      layout: "secondary",
      isLoading: props.isLoading
    });
  }

  const editForm = (
    <>
      {props.introText && <p>{props.introText}</p>}
      <p>{translate("DeVeldenMetEenzijnVerplicht")}</p>
      <Form
        formOptions={{
          defaultValues: props.defaultValues || {},
          mode: "onTouched"
        }}
        onShowButtons={props.onShowButtons}
        uiDefaults={{ flexDirectionFormGroupControl: "row" }}
        fieldDefaults={{
          text: {
            maxLengthMessage: true
          },
          textArea: {
            counterAndMaxLengthMessage: true,
            counterUnit: translate("tekens")
          },
          select: {
            library: SelectLibrary.DownShift
          }
        }}
        dependsOn={{
          keepDefaultValues: true
        }}
        datasources={props.datasources || []}
        buttonList={buttonList}
        schema={props.getSchema()}
      />
      {props.outroText && <div className="outroContainer">{<p>{props.outroText}</p>}</div>}
    </>
  );

  if (props.customClass) {
    return <div className={props.customClass}>{editForm}</div>;
  }
  return editForm;
};
